import FileBase64 from 'react-file-base64';

const InputFileBase64  = ({label , multiple = false , onChange}) => {
    return (
        <div className="card">
            <div className="card-body">
                {label && <label className="card-title mb-2 d-block">{label}</label>}
                <FileBase64
                    multiple={multiple}
                    onDone={ (value) => {onChange(value.base64)} } />
            </div>
        </div>

    );
}

export const InputFileBase64WithoutContainer  = ({label , multiple = false , onChange}) => {
    return (
        <div className="">
            {label && <label className="card-title mb-2 d-block">{label}</label>}
            <FileBase64
                multiple={multiple}
                onDone={ (value) => {onChange(value)} } />
        </div>
    );
}

export default InputFileBase64 ;